import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'ng-template[wrControlTemplate]',
})
export class GenericMultiControlTemplateDirective {

  constructor(
    public readonly templateRef: TemplateRef<any>,
  ) {
  }
}
